import ApiClient from '../client';
const path = require('path');

class ResourceAPI extends ApiClient {

  resourceKinds=undefined;
  
  resourceDataFormats=undefined;

  constructor() {
    super();
  }

  async createResource(data) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      'resources/'
    );
    const response = await this.post(route, data);
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }
  async getResource(id) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `resources/${id}/`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getDatasetResources(datasetId) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `resource-dataset/?dataset_id=${datasetId}`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async createResourceDatasetRelation(data) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      'resource-dataset/'
    );
    const response = await this.post(route, data);
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }
  async getResourceDatasetRelation(id) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `resource-dataset/${id}/`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async getResourceToDatasetScenarios(id) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `resource-dataset/${id}/_scenarios/`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async buildResourceIndex(id, scenarioId, datasetId, asynchrone = true) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `resource-dataset/${id}/_scenarios/${scenarioId}/run/?asynchrone=${asynchrone}`
    );
    const response = await this.post(route, {
      kwargs: {
        target: {
          model: 'dataset',
          app_label: 'onegeo_dataset',
          pk: datasetId
        }
      }
    }, );
    if (response.status === 202) {
      return response.data;
    }
    return false;
  }

  async patchResource(id, data) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `resources/${id}/`
    );
    const response = await this.patch(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async patchResourceGeographicLayer(url, data) {
    const response = await this.patch(url, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async deleteResourceToDataset(id) {
    const route = path.join(this.RESOURCE_API_PATH,
      `resource-dataset/${id}/`
    );
    const response = await this.delete(route);
    if (response.status === 204) {
      return response.data;
    }
    return false;
  }

  async deleteResource(id) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `resources/${id}/`
    );
    const response = await this.delete(route);
    if (response.status === 204) {
      return response.data;
    }
    return false;
  }

  async updateResource(id, data) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `resources/${id}/`
    );
    const response = await this.put(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getResourceDataFormats() {
    if(this.resourceDataFormats){
      return this.resourceDataFormats;
    }
    const route = path.join(
      this.RESOURCE_API_PATH,
      'data-format/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      this.resourceDataFormats=response.data;
      return response.data;
    }
    return false;
  }

  async getResourceData(location) {
    const response = await this.get(location, {
      headers: {
        Referer: window.location.origin,
        Origin: window.location.origin
      },
    });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getResourceExecutionFrequency(location) {
    const response = await this.get(location);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getResourceKinds() {
    if(this.resourceKinds){
      return this.resourceKinds;
    }
    const route = path.join(
      this.RESOURCE_API_PATH,
      'kinds/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      this.resourceKinds=response.data;
      return response.data;
    }
    return false;
  }

  async getResourceScenarios(slug, resourceId) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `${slug}/${resourceId}/_scenarios/`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
};

const resourceAPI = new ResourceAPI();
export default resourceAPI;
